import { render, staticRenderFns } from "./ScrollView.vue?vue&type=template&id=2eb86cf4&scoped=true&"
import script from "./ScrollView.vue?vue&type=script&lang=ts&"
export * from "./ScrollView.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollView.vue?vue&type=style&index=0&id=2eb86cf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb86cf4",
  null
  
)

export default component.exports